import UrlPattern from 'url-pattern';
import { startsWith } from 'lodash';

export function didLocationChangeFromTo({ from, to, routes = [] }) {
  const foundMatch = routes.some(
    ({ fromRoute, toRoute, fromStartsWith, toStartsWith }) => {
      const fromPattern = new UrlPattern(fromRoute || fromStartsWith);
      const toPattern = new UrlPattern(toRoute || toStartsWith);
      const fromMatches = fromPattern.match(from);

      let reconstructedTo;
      let reconstructedStartsWith = false;
      try {
        reconstructedTo = toPattern.stringify(fromMatches);
        reconstructedStartsWith =
          Boolean(toStartsWith) && startsWith(to, reconstructedTo);
      } catch (e) {
        reconstructedTo = null;
      }

      if (fromMatches && (reconstructedTo === to || reconstructedStartsWith)) {
        return true;
      }
      if (
        Boolean(fromStartsWith) &&
        Boolean(toStartsWith) &&
        startsWith(from, fromStartsWith) &&
        reconstructedStartsWith
      ) {
        return true;
      }
      return false;
    },
  );

  return foundMatch;
}
